<appo-avatar
        *ngIf="account.accountType === userAccountType"
        [resource]="account"
        size="big">
</appo-avatar>
<appo-business-logo
        *ngIf="account.accountType !== userAccountType"
        [pictureUrl]="account.pictureUrl">
</appo-business-logo>
